import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { createUpdatingWorkDraft } from '@App/helpers/work-entities/creators'
import { StoresContext } from '@App/contexts'
import { WorkModel } from '@Entities/work/work'
import AddWriterFormFlow from '@Components/WorkRegistrationSubs/AddWriter/AddWriterFormFlow'
import { WriterModel } from '@Entities/work/writer-model'

interface AddWriterProps {
    closePopupFunc(): void
}

const AddWriter = ({ closePopupFunc }: AddWriterProps) => {
    const { workStore, writerSearchStore } = useContext(StoresContext)

    const [writerData, setWriterData] = useState<WriterModel>({
        firstName: '',
        lastName: '',
        ipiNumber: '',
        roleCode: null,
        writerShare: null,
    })

    const closePopupOrClearForm = (closePopup = true) => {
        if (closePopup) {
            closePopupFunc()
        } else {
            setWriterData({
                firstName: '',
                lastName: '',
                ipiNumber: '',
                roleCode: null,
                writerShare: null,
            })
        }
    }

    const addWriterToDraft = (closePopup = true) => {
        const workDraftFromLocal = workStore.workDraftLocal

        if (!workDraftFromLocal) {
            return
        }

        const updatedWork = createUpdatingWorkDraft<WriterModel>(workDraftFromLocal, 'writers', writerData)

        workStore.setWorkDraftToLocal(updatedWork)
        closePopupOrClearForm(closePopup)
    }

    const setFoundWriterToDraft = async (writer: WriterModel, closePopup = true) => {
        const workDraftFromLocal = workStore.workDraftLocal

        if (!workDraftFromLocal) {
            return
        }

        const writers = workDraftFromLocal.writers
        const lastWriterId = writers.length ? Number(writers[writers.length - 1].localId) : 0

        const newWriter: WriterModel = {
            localId: lastWriterId + 1,
            ipId: writer.ipId,
            firstName: writer.firstName ? writer.firstName : null,
            lastName: writer.lastName, // REQUIRED FIELD
            ipiNumber: writer.ipiNumber ? writer.ipiNumber : null,
            roleCode: writer.roleCode,
            writerShare: 0,
        }

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            writers: [...writers, newWriter],
        }

        workStore.setWorkDraftToLocal(updatedWorkDraft)
        closePopupOrClearForm(closePopup)
    }

    useEffect(
        () => () => {
            writerSearchStore.clearStore()
        },
        []
    )

    if (!writerData) {
        return null
    }

    return (
        <div>
            <AddWriterFormFlow
                setFoundWriterToDraft={setFoundWriterToDraft}
                addWriterToDraft={addWriterToDraft}
                writerData={writerData}
                setWriterData={setWriterData}
            />
        </div>
    )
}

export default observer(AddWriter)
